export const PAST = 'past'
export const FUTURE = 'future'
export const DATE = 'date'